import store from '@/vuex';
import storageManager from '@/storage-manager';

export default {
  handleUnauthorised(error) {
    // TODO: any other status codes
    if (!error && !error.response && !error.response.status) {
      return false;
    }
    if (error.response.status === 401) {
      store.commit('user/resetData');
      store.commit('savedItems/resetData');
      store.commit('savedSearches/resetData');
      storageManager.emptySessionStorage({ key: 'saved-items|items' });

      // Redirect users to login on dashboard pages only
      if (window.location.pathname.indexOf('dashboard/') > -1) {
        window.location = '/login';
      }
      // TODO: show flash message, trigger Login?
    }
    return true;
  },
};
